import { Routes, Route } from 'react-router-dom';
import { PrivateZoneList } from './PrivateZoneList';
import { PrivateZoneDetail } from './PrivateZoneDetail';

/**
 * Private Zones module — owner-scoped infrastructure view.
 *   /services/private-zones        → owned-zone list
 *   /services/private-zones/:id     → zone resource dashboard
 */
export function PrivateZonePage() {
  return (
    <Routes>
      <Route index element={<PrivateZoneList />} />
      <Route path=":id" element={<PrivateZoneDetail />} />
    </Routes>
  );
}

export default PrivateZonePage;
